import { useEffect, useState } from "react";

export const PERMISSION_LABELS = {
  "services.write": "Criar/editar serviços",
  "services.delete": "Excluir serviços",
  "professionals.write": "Criar/editar profissionais",
  "professionals.delete": "Excluir profissionais",
  "clients.write": "Criar/editar clientes",
  "clients.delete": "Excluir clientes",
  "appointments.write": "Criar agendamentos",
  "appointments.delete": "Excluir agendamentos",
  "appointments.change_status": "Alterar status do agendamento",
  "payments.charge": "Gerar cobranças (Asaas)",
  "reports.view": "Ver relatórios",
  "settings.write": "Alterar configurações",
  "users.manage": "Gerenciar usuários",
};

export const PERMISSION_GROUPS = [
  { name: "Serviços", perms: ["services.write", "services.delete"] },
  { name: "Profissionais", perms: ["professionals.write", "professionals.delete"] },
  { name: "Clientes", perms: ["clients.write", "clients.delete"] },
  { name: "Agendamentos", perms: ["appointments.write", "appointments.change_status", "appointments.delete"] },
  { name: "Pagamentos", perms: ["payments.charge"] },
  { name: "Relatórios", perms: ["reports.view"] },
  { name: "Configurações", perms: ["settings.write"] },
  { name: "Administração", perms: ["users.manage"] },
];

export function getMe() {
  try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
}

export function useMe() {
  const [me, setMe] = useState(getMe());
  useEffect(() => {
    const onStorage = () => setMe(getMe());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return me;
}

export function can(action) {
  const me = getMe();
  if (!me) return false;
  if (me.role === "owner") return true;
  return (me.permissions || []).includes(action);
}
